import React, { useEffect, useState, useRef } from "react";
import { useParams } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import { useForm, Controller } from 'react-hook-form';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate } from 'react-router-dom';
import Home from '../Home/Home';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import EditIcon from '@mui/icons-material/Edit';
import Alert from '@mui/material/Alert';
import Backdrop from '@mui/material/Backdrop';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { useSelector } from "react-redux";
import {useDispatch} from "react-redux";
import { addActiveEventData, addEventData } from '../../store/adminSlice';





  const EventForm = () => {
    const [formData, setFormData] = useState({
      eventType: '',
      eventYear: '',
      eventMonth: '',
      priceBelow6: '',
      price6to12: '',
      priceAdult: '',
      earlybirdPriceBelow6: '',
      earlybirdPrice6to12: '',
      earlybirdPriceadult: '',
      earlybirdExpiry: null,
      eventStreet: '',
      eventCity: '',
      eventZip: '',
      eventState: '',
      eventVenue: '',
      eventStatus: '',
      eventExpiry: null,
      eventStartDate: null,
      eventEndDate: null,
      registrationStatus: '',
      earlyBirdStatus:''
      });

  
  //const [message, setMessage] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const { eventId } = useParams();
  const [event, setEvent] = useState(null);
  const [isCreating, setIsCreating] = useState(!eventId);
  const [openLoader, setOpenLoader] = React.useState(true);
  const [alertMessage, setAlertMessage] = useState("");
  const navigate = useNavigate();

  const dateRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;

const isValidDateFormat = (date) => {
  return dateRegex.test(date);
};

const isEndDateGreaterThanStartDate = (eventStartDate, eventEndDate) => {
  const start = new Date(eventStartDate);
  const end = new Date(eventEndDate);
  return end > start;
};

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleDateChange = (date,field) => {
    setFormData({
      ...formData,
      [field]:date,
    });
  };

    const {register,  control, formState: { errors }, reset, setError, clearErrors } = useForm()

   
  const handleBack = () => {
    // Navigate back to the previous page
    navigate(-1);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
   
    if (!isEndDateGreaterThanStartDate(formData.eventStartDate, formData.eventEndDate)) {
      setError('eventEndDate', { type: 'manual', message: 'Event End Date must be greater than Event Start Date' });
      return;
    }
    clearErrors('eventEndDate');
    console.log(formData);

    const eventData = {
      eventType: formData.eventType,
      eventCode: parseInt(formData.eventCode, 10),
      eventYear: parseInt(formData.eventYear, 10),
      eventMonth: formData.eventMonth,
      priceBelow6: parseInt(formData.priceBelow6, 10),
      price6to12: parseInt(formData.price6to12, 10),
      priceAdult: parseInt(formData.priceAdult, 10),
      earlybirdPriceBelow6: parseInt(formData.earlybirdPriceBelow6, 10),
      earlybirdPrice6to12: parseInt(formData.earlybirdPrice6to12, 10),
      earlybirdPriceadult: parseInt(formData.earlybirdPriceadult, 10),
      earlybirdExpiry: new Date(formData.earlybirdExpiry),
      earlyBirdStatus: formData.earlyBirdStatus,
      eventStreet: formData.eventStreet,
      eventCity: formData.eventCity,
      eventZip: parseInt(formData.eventZip, 10),
      eventState: formData.eventState,
      eventVenue: formData.eventVenue,
      eventStatus: formData.eventStatus,
      registrationStatus: formData.registrationStatus,
      eventExpiry: new Date(formData.eventExpiry),
      eventStartDate: new Date(formData.eventStartDate) ,
      eventEndDate: new Date(formData.eventEndDate),
    };

    if (isCreating) {
      // Create a new event
     // Send the data to the server using Axios
    axios.post(process.env.REACT_APP_API_URL + '/event/create', eventData)
    .then(response => {
      console.log('Success:', response.data);
      //setMessage('Event created successfully!');
      setAlertMessage("success");
      setIsVisible(true);
    })
    .catch(error => {
      console.error('Error:', error);
      setAlertMessage("error");
     // setMessage('Failed to create event. Please try again.');
    });
    } 
    /*else {
      // Update the existing event
      axios.put(process.env.REACT_APP_API_URL + '/event/update', event)
        .then(response => {
          console.log('Event updated:', response.data);
          //navigate('/'); // Redirect to the home page or another appropriate page
        })
        .catch(error => {
          console.error('Error updating event:', error);
        }
          );
    }*/

    
  };

   
  useEffect(() => {
     
    // Fetch event details based on eventId
    axios.get(`${process.env.REACT_APP_API_URL}/event/get/${parseInt(eventId, 10)}`)
      .then(response => {
        setEvent(response.data);
      })
      .catch(error => {
        console.error('Error fetching event details:', error);
      });
  }, [eventId]);

  if (!event) {
    return (
      <Home>

          <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
            
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <div className="container">
                <div className="row">
                    <div className="col-md-6"> <h1>Create Event</h1> </div>
                   
                    </div> 

                {/*{!event && <Stack spacing={2} direction="row" alignItems="center">*/}
                {/*    <CircularProgress size="10rem"/>*/}
                {/*</Stack> }*/}

                { alertMessage && <Stack>
                    {alertMessage === "success" && <Alert variant="filled" severity="success">
                        Event created Successfully.
                    </Alert>}
                    {alertMessage === "error" && <Alert variant="filled" severity="error">
                    Event creation failed.
                    </Alert>}
                </Stack>}
  <div>
      
  
       
         { <form className="form_design four-column-layout" onSubmit={handleSubmit}>
           <label>
            <b>Event Type:</b>
            <br></br>
            <select
              name="eventType"
              value={formData.eventType}
              className={errors.eventType ? "error_field" : null}
              onChange={handleChange}
              required>
              <option value="">Select an option</option>
              <option value="SARASWATI_PUJO">SARASWATI PUJO</option>
              <option value="DURGA_PUJO">DURGA PUJO</option>
              <option value="BENGALI_NEW_YEAR">BENGALI NEW YEAR</option>
              <option value="SUMMER_PICNIC">SUMMER PICNIC</option>
              required
            </select>
             {errors.eventType?.type === "required" && (
                                    <p role="alert" className="alert_msg">Event Type required</p>
                                )}
                                </label>
                        
                            <label>
                                <b> Price Below 6: </b>
                                <br></br>
                                <input type="number"  className={errors.priceBelow6 ? "error_field" : null}
                                      name="priceBelow6"                                     
                                       value={formData.priceBelow6} onChange={handleChange} required
                                       aria-invalid={errors.priceBelow6 ? "true" : "false"}
                                />
                                {errors.priceBelow6?.type === "required" && (
                                    <p role="alert" className="alert_msg">Price Below 6 required</p>
                                )}
                            </label>

                            <label>
                                <b> Price 6 to 12: </b>
                                <br></br>
                                <input type="number" className={errors.price6to12 ? "error_field" : null}
                                      name="price6to12"   value={formData.price6to12} onChange={handleChange} required
                                       aria-invalid={errors.price6to12 ? "true" : "false"}
                                />
                                {errors.price6to12?.type === "required" && (
                                    <p role="alert" className="alert_msg">Price 6 to 12 required</p>
                                )}
                            </label>
                            <label>
  <b>Price Adult:</b>
  <br />
  <input
    type="number"
    className={errors.priceAdult ? "error_field" : null}
    name="priceAdult"
    value={formData.priceAdult}
    onChange={handleChange}
    required
    aria-invalid={errors.priceAdult ? "true" : "false"}
  />
  {errors.priceAdult?.type === "required" && (
    <p role="alert" className="alert_msg">Price Adult required</p>
  )}
</label>

                            <label>
                                <b> Early Bird Price Below 6: </b>
                                <br></br>
                                <input type="number" defaultValue={formData.earlybirdPriceBelow6} className={errors.earlybirdPriceBelow6 ? "error_field" : null}
                                       name="earlybirdPriceBelow6"   value={formData.earlybirdPriceBelow6} onChange={handleChange} required
                                       aria-invalid={errors.earlybirdPriceBelow6 ? "true" : "false"}
                                />
                                {errors.earlybirdPriceBelow6?.type === "required" && (
                                    <p role="alert" className="alert_msg">Early Bird Price Below 6 required</p>
                                )}
                            </label>

                            <label>
                                <b> Early Bird Price 6 to 12: </b>
                                <br></br>
                                <input type="number" defaultValue={formData.earlybirdPrice6to12} className={errors.earlybirdPrice6to12 ? "error_field" : null}
                                      name="earlybirdPrice6to12"   value={formData.earlybirdPrice6to12} onChange={handleChange} required
                                       aria-invalid={errors.earlybirdPrice6to12 ? "true" : "false"}
                                />
                                {errors.earlybirdPrice6to12?.type === "required" && (
                                    <p role="alert" className="alert_msg">Early Bird Price 6 to 12 required</p>
                                )}
                            </label>

                            <label>
                                <b> Early Bird Price Adult: </b>
                                <br></br>
                                <input type="number" defaultValue={formData.earlybirdPriceadult} className={errors.earlybirdPriceadult ? "error_field" : null}
                                      name="earlybirdPriceadult"   value={formData.earlybirdPriceadult} onChange={handleChange} required
                                       aria-invalid={errors.earlybirdPriceadult ? "true" : "false"}
                                />
                                {errors.earlybirdPriceadult?.type === "required" && (
                                    <p role="alert" className="alert_msg">Early Bird Price Adult required</p>
                                )}
                            </label>

                            <label>
                                <b> Early Bird Expiry: </b>
                                <br></br>
                                
                                <DatePicker
    id="earlybirdExpiry"
    className={errors.earlybirdExpiry ? "error_field" : null}
    selected={formData.earlybirdExpiry}
    onChange={(date) => handleDateChange(date, 'earlybirdExpiry')}
    dateFormat="MM/dd/yyyy"
    required
    aria-invalid={errors.eventExpiry ? "true" : "false"}
  />
                                {errors.earlybirdExpiry?.type === "required" && (
                                    <p role="alert" className="alert_msg">Early Bird Expiry required</p>
                                )}
                            </label>

                            <label>
                                <b> Early Bird Status: </b>
                                <br></br>
                               
                                <select  className={errors.earlyBirdStatus ? "error_field" : null}
                                      name="earlyBirdStatus"   value={formData.earlyBirdStatus} onChange={handleChange} required>
                                    <option value="">Select an option</option>
                                    <option value="A">Active</option>
                                    <option value="I">Inactive</option>

                                </select>

                                

                                {errors.earlyBirdStatus?.type === "required" && (
                                    <p role="alert" className="alert_msg">Early Bird Status required</p>
                                )}
                            </label>

                            <label>
                                <b> Event Registration Status: </b>
                                <br></br>
                                
                                <select defaultValue={formData.registrationStatus} className={errors.registrationStatus ? "error_field" : null}
                                      name="registrationStatus"   value={formData.registrationStatus} onChange={handleChange} required
                                      
                                >   
                                    <option value="">Select an option</option>
                                    <option value="open">Open</option>
                                    <option value="closed">Closed</option>

                                </select>
                                {errors.registrationStatus?.type === "required" && (
                                    <p role="alert" className="alert_msg">Event Registration Status required</p>
                                )}
                            </label>
                             <label>
                                <b> Event Status: </b>
                                <br></br>
                                
                                <select defaultValue={formData.eventStatus} className={errors.eventStatus ? "error_field" : null}
                                      name="eventStatus"   value={formData.eventStatus} onChange={handleChange} required
                                      
                                >   
                                    <option value="">Select an option</option>
                                    <option value="A">Active</option>
                                    <option value="I">Inactive</option>


                                </select>
                                {errors.eventStatus?.type === "required" && (
                                    <p role="alert" className="alert_msg">Event Status required</p>
                                )}
                            </label>
                            <label>
  <b>Event Street:</b>
  <br />
  <input
    type="text"
    className={errors.eventStreet ? "error_field" : null}
    name="eventStreet"
    value={formData.eventStreet}
    onChange={handleChange}
    required
    aria-invalid={errors.eventStreet ? "true" : "false"}
  />
  {errors.eventStreet?.type === "required" && (
    <p role="alert" className="alert_msg">Event eventStreet required</p>
  )}
</label>

<label>
  <b>Event City:</b>
  <br />
  <input
    type="text"
    className={errors.eventCity ? "error_field" : null}
    name="eventCity"
    value={formData.eventCity}
    onChange={handleChange}
    required
    aria-invalid={errors.eventCity ? "true" : "false"}
  />
  {errors.eventCity?.type === "required" && (
    <p role="alert" className="alert_msg">Event City required</p>
  )}
</label>
<label>
  <b>Event Zip:</b>
  <br />
  <input
    type="number"
    className={errors.eventZip ? "error_field" : null}
    name="eventZip"
    value={formData.eventZip}
    onChange={handleChange}
    required
    aria-invalid={errors.eventZip ? "true" : "false"}
  />
  {errors.eventZip?.type === "required" && (
    <p role="alert" className="alert_msg">Event Zip required</p>
  )}
</label>
<label>
  <b>Event State:</b>
  <br />
  <input
    type="text"
    className={errors.eventState ? "error_field" : null}
    name="eventState"
    value={formData.eventState}
    onChange={handleChange}
    required
    aria-invalid={errors.eventState ? "true" : "false"}
  />
  {errors.eventState?.type === "required" && (
    <p role="alert" className="alert_msg">Event State required</p>
  )}
</label>
 <label>
   <b>Event Venue:</b>
   <br />
   <input
     type="text"
     className={errors.eventVenu ? "error_field" : null}
     name="eventVenue"
     value={formData.eventVenue}
     onChange={handleChange}
     required
      aria-invalid={errors.eventVenue ? "true" : "false"}
 />
  {errors.eventVenue?.type === "required" && (
    <p role="alert" className="alert_msg">Event venue required</p>
  )}
</label>
<label>
  <b>Event Expiry:</b>
  <br />
  <DatePicker
    id="eventExpiry"
    className={errors.eventExpiry ? "error_field" : null}
    selected={formData.eventExpiry}
    onChange={(date) => handleDateChange(date, 'eventExpiry')}
    dateFormat="MM/dd/yyyy"
    required
    aria-invalid={errors.eventExpiry ? "true" : "false"}
  />
  {errors.eventExpiry?.type === "required" && (
    <p role="alert" className="alert_msg">Event Expiry required</p>
  )}
</label>
<label>
  <b>Event Start Date:</b>
  <br />
   <Controller
            control={control}
            name="eventStartDate"
            rules={{ required: "Event Start Date is required" }}
            render={({ field }) => (
  <DatePicker
    id="eventStartDate"
    className={errors.eventStartDate ? "error_field" : null}
    selected={formData.eventStartDate}
    onChange={(date) => handleDateChange(date, 'eventStartDate')}
    dateFormat="MM/dd/yyyy"
    required
    aria-invalid={errors.eventStartDate ? "true" : "false"}
   />
            )}
          />
  {errors.eventStartDate?.type === "required" && (
    <p role="alert" className="alert_msg">Event Start Date required</p>
  )}
</label>
<label>
  <b>Event End Date:</b>
  <br />
   <Controller
            control={control}
            name="eventEndDate"
            rules={{ required: "Event End Date is required" }}
            render={({ field }) => (
  <DatePicker
    id="eventEndDate"
    className={errors.eventEndDate ? "error_field" : null}
    selected={formData.eventEndDate}
    onChange={(date) => handleDateChange(date, 'eventEndDate')}
    dateFormat="MM/dd/yyyy"
    required
    aria-invalid={errors.eventEndDate ? "true" : "false"}
  />
            )}
          />
  {errors.eventEndDate?.type === "required" && (
    <p role="alert" className="alert_msg">Event End Date required</p>
  )}

{errors.eventEndDate && <p role="alert" className="alert_msg">{errors.eventEndDate.message}</p>}

</label>
 <div></div>
 <div></div>
 <div></div>
          <button  variant="contained" fullWidth="100%" type="button" className="back-button" onClick={handleBack}>Back</button>
          <button variant="contained" fullWidth="100%" type="submit">Submit</button>
                            <div></div>
                        </form> }
    
      
      </div>
      </div>
      </Home>
    );
  }

  
 
};

export default EventForm;
